import * as React from 'react';

// Props
interface ISvgListProps {
    width?: string;
    height?: string;
}

// Component
export class SvgList extends React.Component<ISvgListProps, {}> {
    static get defaultProps(): ISvgListProps {
        return {
            width: '100%',
            height: '100%',
        };
    }

    public render() {
        return (
            <svg
                width={this.props.width}
                height={this.props.height}
                viewBox="0 0 28 28"
                version="1.1"
                spacing="preserve"
                style={{
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    strokeLineJoin: 'round',
                    strokeMiterLimit: 2,
                }}
            >
                <g transform="matrix(0.736842,0,0,0.736842,0,0)">
                    <g transform="matrix(4.75,0,0,1.01786,0,2.71429)">
                        <path d="M8,1.333L7.714,0L0.286,0L0,1.333L0,6.667L0.286,8L7.714,8L8,6.667L8,1.333Z" />
                    </g>
                    <g transform="matrix(4.75,0,0,1.01786,0,14.9286)">
                        <path d="M8,1.333L7.714,0L0.286,0L0,1.333L0,6.667L0.286,8L7.714,8L8,6.667L8,1.333Z" />
                    </g>
                    <g transform="matrix(4.75,0,0,1.01786,0,27.1429)">
                        <path d="M8,1.333L7.714,0L0.286,0L0,1.333L0,6.667L0.286,8L7.714,8L8,6.667L8,1.333Z" />
                    </g>
                </g>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/svg/SvgList.tsx